import { AxiosError, AxiosResponse } from 'axios';

import { UseQueryOptions, useQuery } from '@pricemoov-oss/moon';

interface AppVersion {
    Id: string;
    Status: 'Completed' | 'todo';
}

export function appVersionQueryDeserializer(response: AxiosResponse<AppVersion>): AppVersion {
    return response?.data;
}

function useAppVersionQuery(
    queryConfig?: UseQueryOptions<AxiosResponse<AppVersion>, AxiosError, AppVersion>
) {
    return useQuery<never, AxiosResponse<AppVersion>, AppVersion, AxiosError>({
        source: 'rest',
        id: 'APP_VERSION_QUERY_ID',
        endPoint: `frontend_version`,
        queryConfig: {
            select: appVersionQueryDeserializer,
            ...queryConfig,
        },
    });
}

export default useAppVersionQuery;
